{
    "ca": {
        "llegenda": [
            {
                "id": "Destroyed",
                "text": "Construccions destruïdes",
                "color": "#b30000"
            },
            {
                "id": "Damaged",
                "text": "Construccions afectades",
                "color": "#f6b055"
            },
            {
                "id": "Possibly damaged",
                "text": "Construccions possiblement afectades",
                "color": "#fbde51"
            },
            {
                "id": "Flooded",
                "text": "Zona inundada el dia 29/10/2024",
                "color": "#83b9c9"
            }
        ],
        "font": "Font: Copernicus",
        "mapbox": {
            "FullscreenControl.Enter": "Pantalla completa",
            "FullscreenControl.Exit": "Torna",
            "ScrollZoomBlocker.CmdMessage": "Fes ⌘ + scroll per fer zoom al mapa",
            "ScrollZoomBlocker.CtrlMessage": "Fes ctrl + scroll per fer zoom al mapa"
        }
    },
    "es": {
        "llegenda": [
            {
                "id": "Destroyed",
                "text": "Construcciones destruidas",
                "color": "#b30000"
            },
            {
                "id": "Damaged",
                "text": "Construcciones afectadas",
                "color": "#f6b055"
            },
            {
                "id": "Possibly damaged",
                "text": "Construcciones probablemente afectadas",
                "color": "#fbde51"
            },
            {
                "id": "Flooded",
                "text": "Zona inundada el día 29/10/2024",
                "color": "#83b9c9"
            }
        ],
        "font": "Fuente: Copernicus",
        "mapbox": {
            "FullscreenControl.Enter": "Pantalla completa",
            "FullscreenControl.Exit": "Vuelve",
            "ScrollZoomBlocker.CmdMessage": "Usa ⌘ + scroll para hacer zoom en el mapa",
            "ScrollZoomBlocker.CtrlMessage": "Usa ctrl + scroll para hacer zoom en el mapa"
        }
    }
}